import React, { Component } from 'react';
import {
    Card,
    Avatar,
    CardHeader,
    CardContent,
    CardMedia
} from '@material-ui/core';
import GridItem from '../Grid/GridItem.jsx';
import Carousel from 'react-slick';
import RatingStar from '../Rating/RatingStar.js';
import HOCLoader from '../HOC/HOCLoader.jsx';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

class ServiceReview extends Component {
    state = {
        ratingList: {
            subRatings: []
        },
        loader: true
    };
    componentDidMount() {
        this.getData();
    }
    getData = () => {
        this.props.serviceRatingAction(
            {
                proServiceId: this.props.data.proServiceId,
                userId: this.props.data.key,
                limit: 10
            },
            this.onDone
        );
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ ratingList: data.data, loader: false });
        }
    };
    render() {
        const settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true
        };

        const { ratingList } = this.state;
        if (ratingList.subRatings.length <= 0) {
            return (
                <p>
                    <FormattedMessage
                        id="rating.notfound"
                        defaultMessage="No rating found"
                    />
                </p>
            );
        }
        return (
            <HOCLoader laoding={this.state.loader}>
                <div className="rating-box">
                    <ul>
                        {ratingList.subRatings.map((rating, index) => {
                            return (
                                <li key={index}>
                                    <div className="lr-user-wr-img">
                                        <img
                                            src={rating.proImage.small}
                                            alt=""
                                        />
                                    </div>
                                    <div className="lr-user-wr-con">
                                        <h6>
                                            {rating.name}
                                            <span>
                                                {rating.ar}
                                                <i
                                                    className="fa fa-star"
                                                    aria-hidden="true"
                                                />
                                            </span>
                                        </h6>{' '}
                                        {/* <span className="lr-revi-date">
                                            19th January, 2017
                                        </span> */}
                                        <p>{rating.review}</p>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </HOCLoader>
        );
    }
}
export default connect(
    null,
    actions
)(ServiceReview);



// WEBPACK FOOTER //
// ./src/components/Providers/ServiceReview.js